'use client'

import { useDialogActions } from '@/components/dialog'
import { getKoalendarUrl } from '@/config/site.config'
import { useConsent } from '@/contexts/ConsentContext'
import { useEffect } from 'react'
import { useCookiesConsentDialog } from '../cookies-dialog'
import { LangCode } from '@/components/i18n/lang-context'

// Define CSS for scrollbar management and conditional display for desktop browsers
const scrollbarCSS = `
@media (min-width: 1024px) {
  .dialog-content-container::-webkit-scrollbar {
    display: none; /* Hide scrollbar for Chrome and Safari */
  }
  .dialog-content-container {
    scrollbar-width: none; /* Hide scrollbar for Firefox */
    -ms-overflow-style: none; /* Hide scrollbar for Internet Explorer and Edge */
  }
}

.dialog-content-container::-webkit-scrollbar {
  width: 8px;
}

.dialog-content-container::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  border-radius: 4px;
}

.dialog-content-container {
  overflow-y: auto; /* Show scrollbar only when needed */
}
`

export function useLBCalendarDialog(langCode: LangCode) {
  const { openDialog } = useDialogActions()
  const { consent } = useConsent()

  // Function to open the calendar dialog
  const openCalendarDialog = (koalendarUrl?: string) => {
    openDialog({ content: <LBCalendarDialogContent _koalendarUrl={koalendarUrl} langCode={langCode}/>, theme: 'light' })
  }

  // Use Cookies Consent Dialog and pass the callback directly
  const { openCookiesConsentDialog } = useCookiesConsentDialog(langCode, openCalendarDialog)

  // Handling calendar dialog based on consent
  const openLBCalendarDialog = (koalendarUrl?: string) => {
    if (consent.contact) {
      openCalendarDialog(koalendarUrl)
    } else {
      openCookiesConsentDialog('simple', langCode)
    }
  }

  return { openLBCalendarDialog }
}

function LBCalendarDialogContent({_koalendarUrl, langCode}: {_koalendarUrl?: string, langCode: LangCode}) {

  const koalendarUrl = _koalendarUrl || getKoalendarUrl(langCode)

  useEffect(() => {
    document.body.style.overflow = 'hidden'
    return () => {
      document.body.style.overflow = 'unset'
    }
  }, [])

  return (!koalendarUrl ? <></> :
    <>
      <style>{scrollbarCSS}</style>
      <div className='flex w-full flex-col items-center justify-center bg-primary'>
        <div className='dialog-content-container -mt-24 mb-[-60px] w-full scale-90 bg-primary sm:mx-[-16px] sm:mt-0 sm:w-[90vw] sm:max-w-[896px] sm:scale-100 md:mb-[-110px] md:mt-[-50px]'>
          <iframe src={koalendarUrl} width="100%" height="800px"></iframe>
        </div>
      </div>
    </>
  )
}
